import { useCallback, useEffect, useState } from "react";
const useApi = ({ queryFn, queryKey, onSuccess, onError, enabled = true, }) => {
    const [data, setData] = useState(null);
    const [status, setStatus] = useState(-1);
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(enabled);
    const [success, setSuccess] = useState(false);
    const refetch = useCallback(async () => {
        const response = await queryFn(queryKey);
        return response;
    }, [JSON.stringify(queryKey)]);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const callQueryFn = async () => {
            try {
                setLoading(true);
                const response = await refetch();
                if (!response) {
                    return;
                }
                if (response.success) {
                    onSuccess && onSuccess(response.result);
                }
                else {
                    onError && onError();
                }
                setData(response.result ?? null);
                setStatus(response.status ?? -1);
                setErrors(response.error ? [response.error] : null);
                setSuccess(response.success);
            }
            catch (_error) {
                setData(null);
                setStatus(-1);
                setErrors(null);
                setSuccess(false);
                onError && onError();
            }
            finally {
                setLoading(false);
            }
        };
        callQueryFn();
    }, [enabled, refetch]);
    return { data, setData, status, errors, loading, success, refetch };
};
export { useApi };
